// extracted by mini-css-extract-plugin
export default {"environment":"Environment_environment__k4YvF","envImages":"Environment_envImages__zq3dd","envSingleImage":"Environment_envSingleImage__OPBar"};